import { apiRequestWithAutoRefresh } from '../utils/apiUtils'
import type { OnboardingProgress } from '../types'

// 我的入職進度：基本資料 / 待簽文件 / 必讀公告 / 第一次計時
export const getOnboardingProgress = async (): Promise<OnboardingProgress> => {
  const result = await apiRequestWithAutoRefresh('/onboarding/progress', { method: 'GET' })
  return result.data
}

export const onboardingService = {
  getOnboardingProgress
}
